var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-cta"},[_c('Icon',{staticClass:"mb-3",attrs:{"name":"grClockForward","width":"36"}}),_c('div',{staticClass:"mb-5"},[_c('h4',{staticClass:"user-cta__title"},[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }